/**
 * Slug utilities for product URLs.
 *
 * Products were historically referenced by English slugs (bianstone-*)
 * but are now stored with Chinese slugs. We keep a fallback mapping so
 * any CMS field or hard-coded link that still uses the old slug keeps
 * working and redirects the user to the correct product. The mapping table
 * itself lives in shared/slugMap.ts so the worker can reverse-map slugs on
 * /api/public/products/:slug lookups.
 */
import { LEGACY_SLUG_MAP } from '../../shared/slugMap';

function extractSlug(value: string): string {
  const match = value.match(/^\/?products\/(.*)$/);
  return match ? match[1] : value;
}

export function resolveProductSlug(slug: string | undefined): string {
  if (!slug) return '';
  const raw = extractSlug(slug);
  return LEGACY_SLUG_MAP[raw] || raw;
}

export function productPath(slug: string | undefined): string {
  const resolved = resolveProductSlug(slug);
  if (!resolved) return '/products';
  return `/products/${encodeURIComponent(resolved)}`;
}

export function productApiPath(slug: string | undefined): string {
  const resolved = resolveProductSlug(slug);
  if (!resolved) return '';
  return `/api/public/products/${encodeURIComponent(resolved)}`;
}
